import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";
const userProfileService = {};

// Detail Runner User
userProfileService.detailRunnerUser = ({ runnerId }) => {
  return fetchV2({
    url: `${env.API_MSP}/users/${runnerId}`,
    method: "get",
  });
};

// List Runner User
userProfileService.listRunnerUser = () => {
  return fetchV2({
    url: `${env.API_MSP}/users?filter[user_type]=2&filter[record_status]=O&page=-1`,
    method: "get",
  });
};

// List Runner User
userProfileService.listCollectorUser = () => {
  return fetchV2({
    url: `${env.API_MSP}/users?filter[user_type]=5&filter[record_status]=O&page=-1`,
    method: "get",
  });
};

// List Role User Profile
userProfileService.listRoleUserProfile = ({ params = {} }) => {
  return fetchV2({
    url: `${env.API_MSP}/users/default-roles`,
    method: "get",
    params: { ...params },
  });
};

// List Email Domain User Profile
userProfileService.listEmailDomainUserProfile = ({ params = {} }) => {
  return fetchV2({
    url: `${env.API_MSP}/users/get-email-domains`,
    method: "get",
    params: { ...params },
  });
};

// List User Profile
userProfileService.listUserProfile = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    // "id",
    // "username",
    // "display_name",
    // "ext_value",
    // "maker_id",
    // "maker_date",
    // "maker.id",
    // "maker.display_name",
    // "checker_id",
    // "checker_date",
    // "checker.id",
    // "checker.display_name",
    // "record_status",
    // "tenant_code",
    // "code",
  ];

  return fetchV2({
    url: `${env.API_MSP}/users`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// Create User Profile
userProfileService.createUserProfile = (data = {}) => {
  return fetchV2({
    url: `${env.API_MSP}/users`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Detail User Profile
userProfileService.detailUserProfile = ({
  userProfileId,
  params = { expand: undefined, fields: undefined },
}) => {
  return fetchV2({
    url: `${env.API_MSP}/users/${userProfileId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || undefined,
      fields: params.fields || undefined,
    },
  });
};

// Update User Profile
userProfileService.updateUserProfile = ({
  userProfileId = undefined,
  data = {},
}) => {
  return fetchV2({
    url: `${env.API_MSP}/users/${userProfileId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};
// myHubsList
userProfileService.myHubsList = (params = {}) => {
  return fetchV2({
    url: `${env.API_MSP}/users/get-my-hubs-list`,
    method: "get",
    params: {
      ...params,
    },
  });
};

// list-logadmin-not-manage-center
userProfileService.listLogAdminNotManageCenter = (params = {}) => {
  return fetchV2({
    url: `${env.API_MSP}/users/list-logadmin-not-manage-center`,
    method: "get",
    params: { page: -1, ...params },
  });
};

// list-hubadmin-not-manage-hub
userProfileService.listHubAdminNotManageHub = (params = {}) => {
  return fetchV2({
    url: `${env.API_MSP}/users/list-hubadmin-not-manage-hub`,
    method: "get",
    params: { page: -1, ...params },
  });
};

// list-runner-is-free
userProfileService.listRunnerIsFree = (params = {}) => {
  return fetchV2({
    url: `${env.API_MSP}/users/list-runner-is-free`,
    method: "get",
    params: { page: -1, ...params },
  });
};

// list-collector-is-free
userProfileService.listCollectorIsFree = (params = {}) => {
  return fetchV2({
    url: `${env.API_MSP}/users/list-collector-is-free`,
    method: "get",
    params: { page: -1, ...params },
  });
};

userProfileService.getModelDependHub = ({ params, pathModel }) => {
  const columnFilter = params.columnFilter || {};
  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/${pathModel}`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// list-user-type
userProfileService.listUserType = () => {
  return fetchV2({
    url: `${env.API_MSP}/users/list-type`,
    method: "get",
  });
};

// list-department
userProfileService.listDepartment = params => {
  return fetchV2({
    url: `${env.API_MSP}/departments`,
    method: "get",
    params,
  });
};

export default userProfileService;
